import { parseZonedDateTime } from '@rematter/common/dateTime';
import { SettingsGroupRecord } from '@rematter/modules/settings/types/settings.types';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const settingsGroupQueryAtom = createQueryAtomFactory(
  'settings.groups',
  (params: { searchTerm?: string; limit?: number; offset?: number }) => ({
    settingsGroups: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
        },
        pagination: {
          offset: params.offset ?? 0,
          limit: params.limit ?? 100,
        },
      },
      entries: {
        id: true,
        name: true,
        description: true,
        icon: true,
        createdAt: true,
        updatedAt: true,
        settings: {
          id: true,
          name: true,
          description: true,
          dataType: true,
          scope: true,
          defaultValue: true,
          constraints: {
            required: true,
            validationExpr: true,
            unique: true,
            multipleValues: true,
            minLength: true,
            maxLength: true,
            minValue: true,
            maxValue: true,
            objectType: true,
            selectOptions: true,
          },
          values: {
            scope: true,
            objectId: true,
            value: true,
          },
          timestamps: {
            createdAt: true,
            updatedAt: true,
          },
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): { settingsGroups: SettingsGroupRecord[]; total: number } => ({
      settingsGroups:
        data?.settingsGroups.entries.map((group) => ({
          id: group.id,
          name: group.name,
          description: group.description,
          icon: group.icon,
          createdAt: group.createdAt,
          updatedAt: group.updatedAt,
          settings: group.settings.map((setting) => ({
            id: setting.id,
            name: setting.name,
            description: setting.description,
            dataType: setting.dataType,
            defaultValue: setting.defaultValue,
            scope: setting.scope,
            constraints: setting.constraints,
            createdAt: parseZonedDateTime(setting.timestamps.createdAt),
            updatedAt: parseZonedDateTime(setting.timestamps.updatedAt),
            values: (setting.values ?? []).filter(
              (v): v is NonNullable<typeof v> => v !== null,
            ),
          })),
        })) ?? [],
      total: data?.settingsGroups.page.total ?? 0,
    }),
  },
);
